import React, { useContext, useEffect, useState } from "react";
import { PopUpContext } from "../context/PopUpContext";

export const PopUp = (props) => {
  const { popUpState, popUpContentState } = useContext(PopUpContext);
  const [popUp, setPopUp] = popUpState;
  const [popUpContent, setPopUpContent] = popUpContentState;

  useEffect(() => {
    setTimeout(() => {
      setPopUp(false)
    }, 2000)
  }, [popUp]);
  return (
    <div
      className={`fixed w-screen flex justify-center inset-x-0 bottom-5 z-[999] px-2 sm:px-0 ${popUp ? " block " : "hidden"}`}
      disabled={!popUp}
    >
      <div className="relative min-w-[300px] bg-white shadow-xl rounded-full	shadow-xl">
        <div className="">
          <div>
            {/* <h2 className="text-xl text-black font-semibold ">
              {popUpContent.heading}
            </h2> */}
            <p className=" text-base text-black w-full text-center p-1 px-6">
              {popUpContent.description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
